export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/UserIconMobile.12caaa56.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};